import { render, staticRenderFns } from "./BackgroundChoice.vue?vue&type=template&id=4f5836a7&scoped=true&"
import script from "./BackgroundChoice.vue?vue&type=script&scoped=true&lang=js&"
export * from "./BackgroundChoice.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./BackgroundChoice.vue?vue&type=style&index=0&id=4f5836a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5836a7",
  null
  
)

export default component.exports